export abstract class Sizes {
	public static readonly LEFT_DRAWER_WIDTH = 260
	public static readonly LEFT_DRAWER_COLLAPSE_WIDTH = 80
	public static readonly TOP_NAV_HEIGHT = 56
	public static readonly NAV_LEFT_PADDING = 32
	public static readonly MLS_OUTER_PADDING = 182
	public static readonly SEARCH_INPUT_HEIGHT = 60
	public static readonly MLS_TABLE_MINIMUM_HEIGHT = 160
	public static readonly LEFT_TABLE_BREAKPOINT = 1279
}
